import { render, staticRenderFns } from "./SiteNavLector.vue?vue&type=template&id=56fbd329&"
import script from "./SiteNavLector.vue?vue&type=script&lang=js&"
export * from "./SiteNavLector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports